import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import UIMessageProvider from '../../../components/common/UIMessageProvider';
import { IconType } from 'react-icons';
import { FaUsers, FaUserFriends, FaUserCheck, FaTachometerAlt } from '../../../utils/iconUtils';

type Tab = {
  id: string;
  label: string;
  icon: IconType;
  path: string;
  description?: string;
  end?: boolean;
};

const UsersLayout: React.FC = () => {
  const location = useLocation();

  const tabs: Tab[] = [
    { id: 'overview', label: 'Dashboard', icon: FaTachometerAlt, path: '.', description: 'Users summary', end: true },
    { id: 'users', label: 'Users', icon: FaUsers, path: 'users', description: 'Manage users' },
    // { id: 'roles', label: 'Roles', icon: FaUserFriends, path: 'roles', description: 'User roles' },
    // { id: 'invitations', label: 'Invitations', icon: FaUserCheck, path: 'invitations', description: 'Invite users' }
  ];

  return (
    <div className="space-y-4">
      <div className="bg-white rounded-xl shadow-soft p-3">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
          <div>
            <h1 className="text-lg font-semibold text-gray-800">
              Users <span className="text-gray-500 text-sm mt-0.5">(Manage user accounts, roles & invites)</span>
            </h1>
          </div>
        </div>

        <div className="mt-3">
          <div className="flex gap-2 overflow-x-auto whitespace-nowrap py-1">
            {tabs.map((tab) => (
              <NavLink
                key={tab.id}
                to={tab.path}
                end={tab.end ?? false}
                className={({ isActive }) =>
                  `inline-flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-all flex-shrink-0 ${
                    isActive
                      ? 'bg-primary-600 text-white shadow'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`
                }
              >
                <tab.icon className="h-4 w-4" />
                <div className="text-left">
                  <span className="font-medium text-sm leading-tight">{tab.label}</span>
                  <p className="text-xs opacity-70 hidden lg:block leading-tight">{tab.description}</p>
                </div>
              </NavLink>
            ))}
          </div>
        </div>
      </div>

      <div className="min-h-[420px]">
        <UIMessageProvider>
          <Outlet />
        </UIMessageProvider>
      </div>
    </div>
  );
};

export default UsersLayout;
